<template>
  <div class="error" v-html="getMessage"></div>
</template>

<script>
export default {
  name: 'Error',
  computed: {
    getMessage() {
      if (this.$route.params.type === '1') {
        return '<p>The test is already started on another device/tab</p>'
      } else if (this.$route.params.type === '2') {
        return '<p>You have already completed the test</p>'
      } else if (this.$route.params.type === '3') {
        return '<p>Test is over</p>'
      } else if (this.$route.params.type === '4') {
        return '<p>You are not invited for the test</p>'
      } else if (this.$route.params.type === '5') {
        return '<p>Your time is over, please contact admin for any issues</p>'
      } else if (this.$route.params.type === '6') {
        return '<p>Your test is already completed or you have reached maximum restart limit.</p> <p>You can contact the test administrator at <a href="mailto:headstart-support@infocusp.com"target="_top"style="color: #319bf5">headstart-support@infocusp.com</a></p><!--<p>OR</p><p><a href="https://meet.google.com/kbg-qghf-ody"target="_blank"style="color: #319BF5">Join this link </a>to get help on video call</p>-->'
      }
      return 'error'
    },
  },
}
</script>

<style scoped>
.error {
  padding: 100px;
}
</style>
